<template>
  <v-container fluid grid-list-md pa-0>
    <ComponentAdminImportNurseryXLS />
  </v-container>
</template>

<script>
import ComponentAdminImportNurseryXLS from "@/components/admin/ComponentAdminImportNurseryXLS";

export default {
  components: {
    ComponentAdminImportNurseryXLS
  }
};
</script>

<style scoped></style>
